export default "__VITE_ASSET__eRQeVSic__"